import { useState } from "react";

import {
	Button,
	CardContent,
	CircularProgress,
	Grid,
	Paper,
	Typography,
} from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import "ag-grid-enterprise";
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-balham.min.css";

import { DateTimePickerComponent } from "@/components/shared/date-time-picker-modal/date-time-picker.component";
import { useRootTypeContext } from "@/pages/configurations/rootTypes/context/RootTypeContext";
import { useDressCacheContext } from "../../context/DressCacheContext";
import { updateDressCache } from "../../repositories/DressCacheRepository";

import { ErrorModal } from "@/components/shared/modal/error-modal";
import { CheckmarkIcon, toast } from "react-hot-toast";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiSelect-outlined.MuiSelect-outlined": {
				height: "70vh",
				minWidth: "200px",
				width: "80%",
				minHeight: "100%",
			},
		},
	}),
);

type Props = {
	isLoading: boolean;
	getRootsFromAPI: Function;
};

export const TableDressCache = ({ isLoading, getRootsFromAPI }: Props) => {
	const { state, actions } = useDressCacheContext();
	const {
		state: { rootTypes },
	} = useRootTypeContext();

	const [showErrorModal, setShowErrorModal] = useState(false);
	const [localError, setLocalError] = useState<string | null>(null);

	const [selected, setSelected] = useState<string[]>(["all"]);
	const [internalValue, setInternalValue] = useState<Date | null>(null);

	const onLocalChange = (e: any) => {
		setSelected([...e.target.selectedOptions].map((o) => o.value));
	};

	const handleRecalculate = async () => {
		try {
			await updateDressCache(
				parseInt(selected[0]),
				internalValue?.toISOString() || "",
			);
			toast("Success!", {
				icon: <CheckmarkIcon />,
			});
		} catch (error) {
			setLocalError(error as string);
			setShowErrorModal(true);
		}
	};

	const dressCacheTitle = (rootNames: string[]) => {
		if (!rootNames[0]) return;
		if (rootNames[0] === "all") return "All";
		if (rootNames.length === 1) return "Root " + rootNames[0];
		else return "Root " + rootNames.join(", ");
	};

	return (
		<>
			{!isLoading ? (
				<>
					<Paper
						style={{
							width: "100%",
							padding: "20px",
							borderRadius: "0.75rem",
						}}
					>
						<Grid container>
							<Grid item xs={12}>
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<Typography
										variant="h5"
										style={{ paddingBottom: "20px", fontWeight: 600 }}
									>
										Update Dress Cache
									</Typography>
								</div>
							</Grid>

							<Grid item md={3} xs={12} style={{ paddingTop: "1rem" }}>
								<select
									className="form-control user-select-none text-center overflow-y scrollbar-native"
									value={selected}
									onChange={onLocalChange}
									size={20}
								>
									<option
										style={{ padding: "0.35rem", fontWeight: "bold" }}
										value={"all"}
									>
										All
									</option>
									{state.roots?.map((root) => {
										const rts = rootTypes.find(
											(rt) => rt.rootTypeId == root.rootTypeId,
										);
										return (
											<option
												style={{ padding: "0.35rem" }}
												value={root.rootName}
											>
												{rts?.rootTypeName} {root.rootName}
											</option>
										);
									})}
								</select>
							</Grid>

							<Grid item md={9} xs={12} style={{ paddingTop: "1px" }}>
								<CardContent>
									<DateTimePickerComponent
										value={internalValue}
										onChange={(date: Date) => setInternalValue(date)}
									/>
									<br />
								</CardContent>
							</Grid>
							<Grid item md={12}>
								<Button
									onClick={handleRecalculate}
									fullWidth={true}
									color="primary"
									variant="contained"
									disabled={selected.length === 0}
								>
									RECALCULATE {dressCacheTitle(selected)}
								</Button>
							</Grid>
						</Grid>
					</Paper>
				</>
			) : (
				<Grid
					container
					justifyContent="center"
					alignItems="center"
					style={{ minHeight: "60px", paddingTop: "15rem" }}
				>
					{/* <LazyLoading /> */}
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<CircularProgress size="3rem" />
					</div>
				</Grid>
			)}
			<ErrorModal onHide={() => setLocalError(null)} error={localError} />
		</>
	);
};
